<template>
  <header class="section-header background-white">
    <h1>{{ titleUserName }} Cellar</h1>
    <div class="row">
      <div>
        <nuxt-link
          to="/cellar/wines/"
          :class="{ active: activeLink === 'wines' }"
        >
          <span
            class="icon-bottle"
            :class="{
              'icon-bottle': activeLink === 'wines',
              'icon-bottle-empty': activeLink !== 'wines',
            }"
          />
          My&nbsp;Wines
        </nuxt-link>
      </div>
      <div>
        <nuxt-link
          to="/cellar/saved/"
          :class="{ active: activeLink === 'saved' }"
        >
          <span
            class="icon-bell"
            :class="{
              'icon-bell': activeLink === 'saved',
              'icon-bell-empty': activeLink !== 'saved',
            }"
          />
          Saved
        </nuxt-link>
      </div>
      <div>
        <nuxt-link
          to="/cellar/lists/"
          :class="{ active: activeLink === 'lists' }"
        >
          <span
            :class="{
              'icon-heart': activeLink === 'lists',
              'icon-heart-empty': activeLink !== 'lists',
            }"
          />
          Lists
        </nuxt-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CellarHeader',
  props: {
    activeLink: {
      type: String,
      default: 'wines',
    },
  },
  computed: {
    titleUserName() {
      return this.$auth.possessiveTitleUserName || 'My'
    },
  },
}
</script>
